<template>
	<div class="generalInfo" :class="{ 'onlyView': getPermissionAction }">
		<div class="truckInfoBlock">
			<div class="truckInfo mb-2">
				<div class="truckInfoTitle">Trailer info</div>
				<field
						width="290px"
						margin="0 0 10px 0"
						label="VIN #"
						placeholder="Enter VIN #"
						@updateInput="onInput($event, 'vin_code')"
						:setInputValue="vin_code"
						tooltip="VIN code must be unique!"
				></field>
				<field
						margin="0 0 10px 0"
						width="290px"
						label="Make"
						placeholder="Enter trailer model"
						@updateInput="onInput($event, 'model')"
						:setInputValue="model"
				></field>
				<field
						margin="0 0 10px 0"
						width="290px"
						label="Plate #"
						placeholder="Enter plate #"
						@updateInput="onInput($event, 'plate')"
						:setInputValue="plate"
				></field>
			</div>
			<div class="truckInfo viewOnly" v-if="!isCreate">
				<div class="truckInfoTitle">Services</div>
				<field
						v-if="trailerTypeId === 2"
						margin="0 0 10px 0"
						width="290px"
						label="Next PM service hours"
						placeholder="-"
						@updateInput="onInput($event, 'make')"
						:setInputValue="services['next_mileage_pm']"
						icon="hh"
						is-disabled
				></field>
				<field
						margin="0 0 10px 0"
						width="290px"
						type="text"
						label="Next alignment date"
						placeholder="-"
						:dateValue="services['next_date_alignment']"
						@updateDate="onDate($event, '')"
						is-date
						is-attach
						is-readonly
				></field>
				<field
						margin="0 0 10px 0"
						width="290px"
						type="text"
						label="Next annual inspection date"
						placeholder="-"
						:dateValue="services['next_date_inspection']"
						@updateDate="onDate($event, '')"
						is-date
						is-attach
						is-readonly
				></field>
			</div>
		</div>
		<div class="truckInfoRight">
			<div class="truckInfoBlock">
				<div class="truckInfo">
					<div class="truckInfoTitle">GPS</div>
					<v-switch
							class="switchFrozen"
							:input-value="gps"
							@change="onSwitch($event, 'gps')"
							label="GPS"
							color="success"
					></v-switch>
					<field
							v-if="gps"
							:class-error="valid.gps_name && valid.gps_name.$error"
							margin="0 10px 0 0"
							width="290px"
							label="Name"
							placeholder="Enter GPS name"
							@updateInput="onInput($event, 'gps_name')"
							:setInputValue="gps_name"
							is-required
					></field>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: "FirstTab",
	props: {
		getPermissionAction: Boolean,
		vin_code: String,
		plate: String,
		model: String,
		isCreate: Boolean,
		services: Object,
		trailerTypeId: Number,
		gps_name: String,
		gps: Boolean,
		valid: Object,
	},
	methods: {
		onInput({ value }, key) {
			this.$emit('updateFirstTab', { value, key });
		},
		onDate(value, key) {
			this.$emit('updateFirstTab', { value, key });
		},
		onSwitch(value, key) {
			this.$emit('updateFirstTab', { value, key });
		}
	}
};
</script>

<style scoped lang="scss">
@import "../../../Trucks/TruckForm/FirstTab/FirstTab";
</style>
